/**
 * A plain-English sentence describing the retry protocol, for a clinic that
 * wants to read its settings back rather than reconstruct them from three
 * separate editors.
 */

const SHORT = {
  monday: "Mon", tuesday: "Tue", wednesday: "Wed", thursday: "Thu",
  friday: "Fri", saturday: "Sat", sunday: "Sun",
};
const ORDER = Object.keys(SHORT);

function dayRange(days) {
  const sorted = ORDER.filter((d) => days.includes(d));
  if (sorted.length === 0) return "no days";
  const idx = sorted.map((d) => ORDER.indexOf(d));
  const contiguous = idx.every((v, i) => i === 0 || v === idx[i - 1] + 1);
  if (contiguous && sorted.length > 2) return `${SHORT[sorted[0]]}–${SHORT[sorted[sorted.length - 1]]}`;
  return sorted.map((d) => SHORT[d]).join(", ");
}

export function describeProtocol({ attemptGapsDays = [], callingSlots = {}, callingDays = [] }) {
  const starts = Object.values(callingSlots).map((p) => p?.[0]).filter(Boolean).sort();
  const ends = Object.values(callingSlots).map((p) => p?.[1]).filter(Boolean).sort();
  const hours = starts.length ? `between ${starts[0]} and ${ends[ends.length - 1]}` : "at any time";
  const days = dayRange(callingDays);
  if (attemptGapsDays.length === 0) return `One attempt, ${hours}, ${days}.`;
  const steps = attemptGapsDays.map((g) => `then ${g} day${g === 1 ? "" : "s"} later`).join(", ");
  return `Up to ${attemptGapsDays.length + 1} attempts: the first call, ${steps}, ${hours}, ${days}, in a different part of the day each time.`;
}
